import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Chip, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { vehicleSelectedHref } from '../../../vehicles/utils/vehicleUrlParams.ts';
import type { VehicleType } from '../../types/vehicleTypeTypes.ts';

const MAX_VISIBLE = 5;

interface VehicleListCellProps {
  vehicles: NonNullable<VehicleType['vehicles']>;
}

export default function VehicleListCell({ vehicles }: VehicleListCellProps) {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);

  if (vehicles.length === 0) return null;

  const hidden = vehicles.slice(MAX_VISIBLE);
  const hasMore = hidden.length > 0;
  const shown = expanded ? vehicles : vehicles.slice(0, MAX_VISIBLE);

  return (
    <Box>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: `repeat(${MAX_VISIBLE}, max-content)`,
          gap: 0.5,
        }}
      >
        {shown.map(v => (
          <Chip
            key={v.id}
            component={RouterLink}
            to={vehicleSelectedHref(v.id)}
            label={v.registrationNumber}
            size="small"
            variant="outlined"
            clickable
          />
        ))}
      </Box>
      {hasMore && (
        <Link
          component="button"
          variant="body2"
          onClick={e => {
            e.stopPropagation();
            setExpanded(prev => !prev);
          }}
          sx={{ mt: 0.5 }}
        >
          {expanded ? t('common.showLess') : t('common.showMore', { count: hidden.length })}
        </Link>
      )}
    </Box>
  );
}
